/**
 * @Description:用户管理
 * @Version: 1.0
 * @Author: 琴时
 */
import { query, post, update, remove } from './request'
const baseURL = '/api'
const basePublicURL = '/api/public/user'
const baseMangeURL = '/api/mange/user'

// 账号登录
export const Login = params => post(`${baseURL}/login`, params)
//账号注册
export const Register = params => post(`${baseURL}/register`, params)
//找回密码
export const Forget = params => post(`${baseURL}/forget`, params)
// 获取登录用户数据
export const getUserInfo = () => query(`${baseURL}/userInfo`)
// 修改个人数据
export const changeApi = params => update(`${basePublicURL}/update`, params)
// 修改用户密码
export const changeUserPwd = params =>
  update(`${basePublicURL}/updatePwd`, params)
// 更换头像
export const changeImageApi = params =>
  update(`${basePublicURL}/updateImg`, params)
// 查询单个用户数据
export const queryApi = params => query(`${baseMangeURL}/query/${params}`)
// 重置用户密码
export const resetApi = params => update(`${baseMangeURL}/reset`, params)
// 分配用户权限
export const updateApi = params => update(`${baseMangeURL}/update`, params)
// 删除用户
export const removeApi = params => remove(`${baseMangeURL}/delete/${params}`)
// 批量删除
export const mulRemoveApi = params => post(`${baseMangeURL}/delete`, params)
// 发送邮箱验证码
export const sendEmailCode = params =>
  query(`${basePublicURL}/sendCode`, params)
// 绑定邮箱地址
export const bindEmail = params =>
  update(`${basePublicURL}/updateEmail`, params)
